import { sendDeleteTasks } from "@/models/tasks.model";
import { genericFailureToast } from "@/utils/utils";

type UseDeleteTaskProps = {
  onTaskDeleted: () => Promise<void>;
};

export default function useDeleteTask({ onTaskDeleted }: UseDeleteTaskProps) {
  async function deleteTask(taskID: number) {
    try {
      const res = await sendDeleteTasks({ taskIDs: [taskID] });
      if (res.rStatus === "success") {
        if (onTaskDeleted) await onTaskDeleted();
      } else {
        genericFailureToast("Error deleting task");
      }
    } catch (error) {
      console.log("Error deleting task:", error);
      genericFailureToast(
        "An unexpected error occurred while deleting the task."
      );
    }
  }

  return { deleteTask };
}
